export default __webpack_public_path__ + "static/media/arihant2.30214012.mpeg";